import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import fetchStaticProps from '/business/shared/state/actions/staticProps/fetchStaticProps';

import { getCountries } from '/shared/state/actions/location';
import isLoadingSelector from '/shared/state/selectors/isLoadingSelector';
import hasCountriesSelector from '/shared/state/selectors/hasCountriesSelector';
import hasStaticPropsSelector from '/business/shared/state/selectors/staticProps/hasStaticPropsSelector';
import isAuthedSelector from '/business/shared/state/selectors/auth/isAuthedSelector';
import useHasChanged from '/business/shared/hooks/useHasChanged';
import getApplicationIdSelector from '/business/shared/state/selectors/application/getApplicationIdSelector';
import getApplicationPackages from '/business/shared/state/actions/applications/getApplicationPackages';
import getAnnualUpdates from '/business/shared/state/actions/applications/getAnnualUpdates';
import getApplication from '/business/shared/state/actions/application/getApplication';
import type { LegacyDispatch } from '/business/shared/state/actions/types';
import type { RootState } from '/business/shared/state/store';

export function FetchInitial() {
  const dispatch = useDispatch<LegacyDispatch>();

  const isAuthed = useSelector(isAuthedSelector) || false;
  // const token = useSelector(getSessionTokenSelector) || null;
  const hasCountries = useSelector(hasCountriesSelector) || null;
  const hasStaticProps = useSelector(hasStaticPropsSelector) || false;
  const isLoadingStaticProps = useSelector((state: RootState) => isLoadingSelector(state, 'staticProps')) || false;
  const fetchedAnnualUpdates = useSelector((state: RootState) => state.applications?.fetchedAnnualUpdates) || false;
  const isLoadingCountries = useSelector((state: RootState) => isLoadingSelector(state, 'location')) || false;
  // const isLoadingApplications = useSelector((state) => isLoadingSelector(state, 'applications')) || false;
  const fetchedApplicationPackages = useSelector((state: RootState) => state.applications?.fetchedPackages) || false;
  const isLoadingHasChanged = useHasChanged(isLoadingStaticProps);

  const applicationId = useSelector(getApplicationIdSelector);

  useEffect(() => {
    if (isAuthed && !fetchedApplicationPackages) {
      dispatch(getApplicationPackages());
    }
  }, [dispatch, isAuthed, fetchedApplicationPackages]);

  useEffect(() => {
    if (isAuthed && applicationId) {
      dispatch(getApplication(applicationId));
    }
  }, [dispatch, isAuthed, applicationId]);

  useEffect(() => {
    if (isAuthed && !fetchedAnnualUpdates) {
      dispatch(getAnnualUpdates());
    }
  }, [dispatch, isAuthed, fetchedAnnualUpdates]);

  useEffect(() => {
    if (isAuthed && !isLoadingCountries && !hasCountries) {
      dispatch(getCountries({ useB2BMarkets: true }));
    }
  }, [dispatch, isAuthed, hasCountries, isLoadingCountries]);

  useEffect(() => {
    if (!hasStaticProps && !isLoadingStaticProps && isAuthed && !isLoadingHasChanged) {
      dispatch(fetchStaticProps());
    }
  }, [dispatch, hasStaticProps, isLoadingStaticProps, isAuthed, isLoadingHasChanged]);

  return null;
}

export default FetchInitial;
